
export const BREAK_LOOP=400;

export const TILE_TYPE = {
    CLICKED: "click",
    UNCLICKED: "notClicked",
    FLAG: "flag",
    REVEALED_MINE: "mine",
}

export const  MIN_BOARD_WIDTH=400
export const  MIN_BOARD_HEIGHT=400
export const MIN_TILE_SIZE=30

export const MAX_OBJ_SIZE_IN_DB = 5000;

export const MAX_WIDTH=300;
export const MAX_HEIGHT=300;
